var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1030,
    height: 786,
    viewBox: "0 0 1030 786",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.218 2.87071C292.542 2.87071 325.86 13.0617 357.168 33.3002C387.614 52.821 414.901 80.954 438.454 116.694C462.006 152.578 480.533 194.347 493.458 240.852C506.814 289.08 513.707 340.179 513.707 393C513.707 445.821 506.958 496.92 493.458 545.148C480.533 591.653 462.006 633.422 438.454 669.306C414.901 705.046 387.614 733.179 357.168 752.7C325.86 772.938 292.542 783.129 258.218 783.129C223.894 783.129 190.576 772.938 159.268 752.7C128.822 733.179 101.535 705.046 77.9824 669.306C54.4297 633.422 35.9035 591.653 22.9782 545.148C9.62214 496.92 2.87228 445.821 2.87228 393C2.87228 340.179 9.62214 288.937 23.1219 240.852C36.0471 194.347 54.5733 152.578 78.126 116.694C101.679 80.954 128.965 52.821 159.412 33.3002C190.576 13.0617 223.894 2.87071 258.218 2.87071ZM258.218 0C115.609 0 0 175.974 0 393C0 610.026 115.609 786 258.218 786C400.827 786 516.436 610.026 516.436 393C516.436 175.974 400.827 0 258.218 0Z",
    fill: "url(#paint0_linear_0_203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.406 2.87071C463.73 2.87071 497.048 13.0617 528.356 33.3002C558.802 52.821 586.089 80.954 609.642 116.694C633.194 152.578 651.721 194.347 664.646 240.852C678.002 289.08 684.895 340.179 684.895 393C684.895 445.821 678.146 496.92 664.646 545.148C651.721 591.653 633.194 633.422 609.642 669.306C586.089 705.046 558.802 733.179 528.356 752.7C497.048 772.938 463.73 783.129 429.406 783.129C395.082 783.129 361.764 772.938 330.456 752.7C300.01 733.179 272.723 705.046 249.17 669.306C225.618 633.422 207.091 591.653 194.166 545.148C180.81 496.92 173.917 445.821 173.917 393C173.917 340.179 180.666 288.937 194.166 240.852C207.091 194.347 225.618 152.578 249.17 116.694C272.723 80.954 300.01 52.821 330.456 33.3002C361.764 13.0617 395.082 2.87071 429.406 2.87071ZM429.406 0C286.797 0 171.188 175.974 171.188 393C171.188 610.026 286.797 786 429.406 786C572.015 786 687.624 610.026 687.624 393C687.624 175.974 572.015 0 429.406 0Z",
    fill: "url(#paint1_linear_0_203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.594 2.87071C634.918 2.87071 668.236 13.0617 699.544 33.3002C729.99 52.821 757.277 80.954 780.83 116.694C804.382 152.578 822.909 194.347 835.834 240.852C849.19 289.08 856.083 340.179 856.083 393C856.083 445.821 849.333 496.92 835.834 545.148C822.909 591.653 804.382 633.422 780.83 669.306C757.277 705.046 729.99 733.179 699.544 752.7C668.236 772.938 634.918 783.129 600.594 783.129C566.27 783.129 532.952 772.938 501.644 752.7C471.198 733.179 443.911 705.046 420.358 669.306C396.806 633.422 378.279 591.653 365.354 545.148C351.998 496.92 345.105 445.821 345.105 393C345.105 340.179 351.854 288.937 365.354 240.852C378.279 194.347 396.806 152.578 420.358 116.694C443.911 80.954 471.198 52.821 501.644 33.3002C532.952 13.0617 566.27 2.87071 600.594 2.87071ZM600.594 0C457.985 0 342.376 175.974 342.376 393C342.376 610.026 457.985 786 600.594 786C743.203 786 858.812 610.026 858.812 393C858.812 175.974 743.203 0 600.594 0Z",
    fill: "url(#paint2_linear_0_203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.782 2.87071C806.106 2.87071 839.424 13.0617 870.732 33.3002C901.178 52.821 928.465 80.954 952.018 116.694C975.57 152.578 994.096 194.347 1007.02 240.852C1020.38 289.08 1027.27 340.179 1027.27 393C1027.27 445.821 1020.52 496.92 1007.02 545.148C994.096 591.653 975.57 633.422 952.018 669.306C928.465 705.046 901.178 733.179 870.732 752.7C839.424 772.938 806.106 783.129 771.782 783.129C737.458 783.129 704.14 772.938 672.832 752.7C642.386 733.179 615.099 705.046 591.546 669.306C567.994 633.422 549.467 591.653 536.542 545.148C523.186 496.92 516.293 445.821 516.293 393C516.293 340.179 523.042 288.937 536.542 240.852C549.467 194.347 567.994 152.578 591.546 116.694C615.099 80.954 642.386 52.821 672.832 33.3002C704.14 13.0617 737.458 2.87071 771.782 2.87071ZM771.782 0C629.173 0 513.564 175.974 513.564 393C513.564 610.026 629.173 786 771.782 786C914.391 786 1030 610.026 1030 393C1030 175.974 914.391 0 771.782 0Z",
    fill: "url(#paint3_linear_0_203)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_203",
    x1: 0,
    y1: 392.971,
    x2: 516.465,
    y2: 392.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08475E",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_203",
    x1: 171.174,
    y1: 392.978,
    x2: 687.638,
    y2: 392.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#08475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_203",
    x1: 342.333,
    y1: 392.971,
    x2: 858.812,
    y2: 392.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#08475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_203",
    x1: 513.506,
    y1: 392.971,
    x2: 1029.97,
    y2: 392.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#08475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1030,
    height: 786,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolor);
export default __webpack_public_path__ + "static/media/solor.a8128e2753b0718d6c20390e8c3007aa.svg";
export { ForwardRef as ReactComponent };